module.exports = __webpack_public_path__ + "img/wallet_enable.cb7a8554.svg";